import axios, { AxiosResponse } from 'axios'
import { CommonFilterModel, CommonParams, ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { BillingCaseResponse } from '@/api/services/billing/case-grid/billing-case.dto'
import { ReportGridRequest } from '@/api/services/common.dto'
import { Nullable } from '@/shared/types/app.types'

export enum BillingCaseCategory {
    HAS_UNAUTHORIZED_BILLABLE_CONCEPTS = 'hasUnauthorizedBillableConcepts',
    HAS_NO_CONCEPTS = 'hasNoConcepts',
    HAS_CONCEPTS_WITHOUT_CUSTOMER_AND_RATE = 'hasConceptsWithoutCustomerAndRate',
    HAS_CONCEPTS_WITH_ONLY_RATE = 'hasConceptsWithOnlyRate',
    HAS_CONCEPTS_WITH_ONLY_CUSTOMER = 'hasConceptsWithOnlyCustomer',
    HAS_CONCEPTS_NOT_TO_BE_ADDED_TO_INVOICE = 'hasConceptsNotToBeAddedToInvoice',
    HAS_AUTOMATIC_BILLABLE_CONFLICTS = 'hasAutomaticBillableConflicts'
}

class BillingCaseService {
    async deleteAutomaticBillableConflicts(
        laboratoryId: number,
        request: EntityIdentifiersRequest
    ): Promise<EntityIdentifierWithErrorResponse[]> {
        const response =
            await axios.delete<EntityIdentifierWithErrorResponse[]>(
                `/billing/laboratories/${laboratoryId}/case/automaticBillableConflict/batch`,
                { data: request })
        return response.data
    }

    async paginator(
        filterModel: Nullable<CommonFilterModel>,
        params: Nullable<CommonParams>,
        laboratoryId: number,
        category: BillingCaseCategory
    ): Promise<IResponseAgGrid<BillingCaseResponse>> {
        const mode = category ? `/${category}` : ''
        const response =
            await axios.put<IResponseAgGrid<BillingCaseResponse>>(
                `/billing/laboratories/${laboratoryId}/cases${mode}`,
                { ...filterModel },
                { params })
        return response.data
    }

    async export(
        laboratoryId: number,
        gridColumns?: ReportGridRequest,
        params?: ExportCommonParams,
        category?: BillingCaseCategory
    ): Promise<AxiosResponse<Blob>> {
        const mode = category ? `/${category}` : ''
        return axios.put<Blob>(
            `/billing/laboratories/${laboratoryId}/cases${mode}/export`,
            { ...gridColumns },
            { params, responseType: 'arraybuffer' })
    }
}
export const billingCaseService = new BillingCaseService()
